import { StringEndRegex, StringStartRegex, PhoneType } from "@/lib/utilities/enums";
import { exists } from "@/lib/utilities";
import store from "../../../store";

// Could be this, or non-digits...?
export const PhoneNumberReplacements = /[().,\- ]/g;

// North American Numbering Plan
export const NANPRegex = /^([0-9]{3})([0-9]{3})([0-9]{4})$/;
// Any regions other than North America
export const GlobalRegex = /^[0-9]{4,14}$/;
export const ExtensionRegex = /^[.x*]? ?[0-9]{0,4}$/;

export const PhoneInputDefaultCountry = {
  id: 1,
  abbr: "US",
  code: "1",
  flag: "/static/assets/img/us-flag.svg"
};

export const PhoneInputCountryOptions = [
  PhoneInputDefaultCountry,
  {
    id: 2,
    abbr: "CA",
    code: "1",
    flag: "/static/assets/img/canada-flag.svg"
  },
  {
    id: 3,
    abbr: "GB",
    code: "44",
    flag: "/static/assets/img/gb-flag.svg"
  },
  {
    id: 4,
    abbr: "FR",
    code: "333",
    flag: "/static/assets/img/fr-flag.svg"
  }
];

export function getPhoneTypeName(phone) {
  if (!phone) return "";

  let _type = phone.phoneTypeId || 0;
  let _name = "Phone";
  if (_type == PhoneType.CellPhone || phone.isMobile) _name = "Cell";
  else if (_type == PhoneType.WorkPhone) _name = "Work";
  else if (_type == PhoneType.HomePhone || _type == PhoneType.Unknown) _name = "Home";
  return _name;
}

// TODO: Determine the proper way we should determine if NANP... How to treat empty inputs?
export function phoneIsFromNANP({ cc }) {
  return !cc || Object.keys(cc).length === 0 || cc.code == "1";
}

export function getPhoneNumberPattern(rawPhoneObj) {
  if (phoneIsFromNANP(rawPhoneObj)) {
    return NANPRegex;
  } else {
    return GlobalRegex;
  }
}

export function cleanPhoneNumber(rawPhoneObj) {
  const { phone } = rawPhoneObj;
  if (!phone) return "";
  return phone.replace(PhoneNumberReplacements, "");
}

export function validatePhoneNumber(rawPhoneObj) {
  const { extension } = rawPhoneObj;
  const phone = cleanPhoneNumber(rawPhoneObj);
  const pattern = getPhoneNumberPattern(rawPhoneObj);

  let errs = [];
  if (pattern && exists(phone)) {
    if (!pattern.test(phone)) errs.push("Invalid number");
  }
  if (extension) {
    if (!ExtensionRegex.test(extension)) errs.push("Invalid extension");
  }
  return errs;
}

export function formatPhoneNumber(rawPhoneObj, userConfig = {}) {
  const config = {
    emptyReturnValue: "N/A",
    ...userConfig
  };

  if (!rawPhoneObj) return config.emptyReturnValue;

  const { cc: ccRaw, phone, ext, phoneDisplay } = rawPhoneObj;

  if (!phone && !phoneDisplay) return config.emptyReturnValue;

  let cc;
  if (!ccRaw || Object.keys(ccRaw).length == 0) cc = PhoneInputDefaultCountry;
  else cc = ccRaw;

  let base;
  if (phoneDisplay) base = phoneDisplay;
  else {
    if (phoneIsFromNANP(rawPhoneObj) && validatePhoneNumber(rawPhoneObj)) {
      base = phone.replace(NANPRegex, "($1) $2-$3");
    } else {
      base = phone;
    }
  }

  base = base.replace(StringStartRegex, `+${cc.code} `);

  if (ext) {
    base = base.replace(StringEndRegex, `x${ext}`);
  }

  return base;
}

export function getPhoneList(contactPhones) {
  if (contactPhones && contactPhones.length > 0) {
    let localPhones = JSON.parse(JSON.stringify(contactPhones));
    localPhones = localPhones.filter(phone => phone.phone && phone.phone.trim());
    localPhones.sort((a, b) => {
      if (a.isPreferred != b.isPreferred) return b.isPreferred - a.isPreferred;
      else return new Date(b.updatedt) - new Date(a.updatedt);
    });

    let phoneList = {};
    let cellPhone;
    let homePhone;
    let workPhone;

    cellPhone = localPhones.find(p => p.phoneTypeId == PhoneType.CellPhone);
    homePhone = localPhones.find(p => p.phoneTypeId == PhoneType.HomePhone && !p.isMobile);
    workPhone = localPhones.find(p => p.phoneTypeId == PhoneType.WorkPhone && !p.isMobile);

    if (!homePhone || !cellPhone) {
      localPhones = localPhones.filter(phone => phone.Unknown);

      if (!homePhone) homePhone = localPhones.find(p => !p.isMobile);
      if (!cellPhone) cellPhone = localPhones.find(p => p.isMobile);

      if (homePhone) homePhone.phoneTypeId = PhoneType.HomePhone;
      if (cellPhone) cellPhone.phoneTypeId = PhoneType.CellPhone;
    }

    phoneList.cellPhone = cellPhone ? cellPhone : null;
    phoneList.homePhone = homePhone ? homePhone : null;
    phoneList.workPhone = workPhone ? workPhone : null;

    return phoneList;
  }
  return {};
}

export function createNewPhoneRecord(
  accountId,
  accountPlatformId,
  phoneTypeId
) {
  if (accountId && accountPlatformId && phoneTypeId) {
    return {
      id: 0,
      contactPhoneId: 0,
      contactId: 0,
      accountId: accountId,
      accountPlatformId: accountPlatformId,
      phone: "",
      optOut: false,
      isMobile: false,
      optOutSms: false,
      isPreferred: false,
      phoneTypeId: phoneTypeId
    };
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/lib/utilities/helpers/phone.js